export default __webpack_public_path__ + "static/media/eye-purple.d29ad0d2.png";